<script lang="ts">
export default {
  name: 'CustomerLayout',
};
</script>
<script setup lang="ts">
import { useAuthStore } from '@/stores/auth.store';

import AppNavBar from '@/components/app-layouts/AppNavBar.vue';
import AppFooter from '@/components/app-layouts/AppFooter.vue';
import LoadingPanel from '../LoadingPanel.vue';

import ImpersonationBar from '@/components/impersonation/ImpersonationBar.vue';
import PartnerSideBar from '@/components/app-layouts/PartnerSideBar.vue';

const { hasAuthenticated } = useAuthStore();
const isAuthenticated = hasAuthenticated();
</script>

<template>
  <template v-if="!isAuthenticated">
    <main class="relative h-full">
      <div class="h-full p-4">
        <LoadingPanel />
      </div>
    </main>
  </template>
  <template v-else>
    <div class="flex flex-col min-h-full">
      <ImpersonationBar />
      <AppNavBar :show-tenant-name="false" />
      <PartnerSideBar />
      <main class="relative xl:ml-64 grow flex flex-col justify-between">
        <div class="p-4 xl:pl-5 xl:pr-8">
          <RouterView />
        </div>
        <AppFooter />
      </main>
    </div>
  </template>
</template>
